// extracted by mini-css-extract-plugin
export var image = "gt_c5";